import { cn } from '@/utils/twx';

const XIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="29"
    viewBox="0 0 28 29"
    fill="none"
    className={cn('text-cds-coolgray-80', className)}
  >
    <path
      d="M7 21.5L20.93 7.5M21 21.5L7.07 7.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default XIcon;
